import { useState } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useInterval } from 'react-use';

export const CheckoutEmptyCart = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(3);

  useInterval(() => {
    if (count > 0) {
      setCount(count - 1);
    }
    if (count === 0) {
      navigate('/');
    }
  }, 1000);

  return (
    <Card>
      <Card.Header className="bg-didxl text-white" />
      <Card.Body>
        Shopping cart is empty. You will be redirected to the dashboard in{' '}
        {count}...
      </Card.Body>
    </Card>
  );
};
